<template>
  <div class="solution-tab tab">
    <div class="tab-title" v-text="data.name" />
    <div class="choice-container">
      <div v-for="choice in state.solutions" :key="choice.id" class="choice" @click="goToCrisp(choice)">
        <div class="round-icon">
          <i class="bi" :class="choice.icon" />
        </div>
        <div class="choice-content">
          <div class="choice-name" v-text="choice.name" />
          <p v-text="choice.description" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, inject } from "vue";

const crisp = inject("crisp");

const emits = defineEmits(["next"]);

const { t } = useI18n();

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

function goToCrisp(choice) {
  crisp.chat.open();
  crisp.message.sendText(`${props.data.name}, ${choice.name.toLowerCase()}.`);
  emits("close");
}

const state = reactive({
  solutions: [
    {
      icon: "bi-gift",
      name: t("app.modals.help.solution.sol1.title"),
      description: t("app.modals.help.solution.sol1.text"),
    },
    {
      icon: "bi-chat-left-dots",
      name: t("app.modals.help.solution.sol2.title"),
      description: t("app.modals.help.solution.sol2.text"),
    },
  ],
});
</script>
